import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { hideOnboarding, setMobileHomepage, setWizardDesktop } from '../onboardingSlice';
import { scrollToResults } from '../../../utilities/helpers';
import { t } from '../../../utilities/translator';
import { updateMainFilterFromUrl } from '../../mainFilter/mainFilterSlice';
import { updateSecondaryFilterFromUrl } from '../../secondaryFilter/secondaryFilterSlice';
import { WIZARD_AI_RESPONSE_RECEIVED } from '../../../constants/analyticEvents';
import { isMobile } from '../../../utilities/helpers';
import { pushEvent } from '../../../utilities/analytics';
import { setAppState } from '../../../appSlice';

const LoadingStepAI = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { prompt, promptType, whisper } = useSelector(state => state.onboarding.formV2);
  const [processId, setProcessId] = useState('');
  const [timestamp, setTimestamp] = useState(null);

  useEffect(() => {
    const conversationId = localStorage.getItem('conversationId');
    if (conversationId) {
        sendMessage(prompt);
    } else {
      startConversation()
        .then(() => sendMessage(prompt))
    }
  }, [prompt])

  const hideStaticWizard = () => {
    document.getElementById('mobile-preload-container')?.remove();
  };

  const startConversation = async () => {
    const response = await fetch(window.apiV6Config.path+'/chat/conversation', { method: 'POST' });
    const data = await response.json();
    localStorage.setItem('conversationId', data.conversation.conversationId);
    return data;
  }

  const sendMessage = async (message) => {
    let conversationId = localStorage.getItem('conversationId');
    if (!conversationId) {
      await startConversation();
      conversationId = localStorage.getItem('conversationId');
    }

    setTimestamp(new Date());

    const response = await fetch(window.apiV6Config.path+`/chat/message/send`, {
      method: 'POST',
      body: JSON.stringify({
        message,
        conversationId,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = await response.json();

    if (data.status === 'ERROR') {
      localStorage.removeItem('conversationId');
      return sendMessage(message);
    }
    if (data?.conversation?.processId) {
      setProcessId(data.conversation.processId);
    }
    return data;
  }

  useEffect(() => {
    if (processId) {
      const conversationId = localStorage.getItem('conversationId');

      const finishLoading = () => {
        setTimeout(() => {
          dispatch(setWizardDesktop(false));
          dispatch(setMobileHomepage(false));
          hideStaticWizard();
          dispatch(hideOnboarding());
          scrollToResults();
          if (typeof window.initiateOneTapLogin === 'function') {
            window.initiateOneTapLogin();
          }
          dispatch(setAppState({ wizardCompleted: true }));
        }, 2000)
      }

      const pollStatus = async () => {
        try {
          const response = await fetch(window.apiV6Config.path+`/chat/conversation/status?processId=${processId}&conversationId=${conversationId}&marketId=${window.holidayFinder.market}`);
          const data = await response.json();

          if (data.status === 'completed' || data.status === 'failed') {
            const status = data.status === 'completed' ? 'Success' : 'Failed';
            let eventData = {
              response: data.conversation?.messages[0]?.message,
              responseTime: +((Date.now() - timestamp) / 1000).toFixed(2),
              promptType,
              prompt,
              status,
            }

            if (whisper) {
              eventData = {
                ...eventData,
                ...whisper,
              }
            }
            pushEvent(WIZARD_AI_RESPONSE_RECEIVED, eventData)
          }

          if (data.status === 'completed') {
            const url = data.conversation?.messages[0]?.message;

            if (url.includes('defaultChildAges=')) {
              setTimeout(() => {
                dispatch(setAppState({ guestFilterTooltip: true }));
              }, 2000)
            }

            navigate({ hash: url });
            dispatch(updateMainFilterFromUrl());
            dispatch(updateSecondaryFilterFromUrl());
            finishLoading();
          } else if (data.status === 'failed' || data.status === 'ERROR') {
            console.error('Process failed:', data);
            finishLoading();
          } else {
            setTimeout(pollStatus, 1000);
          }
        } catch (error) {
          console.error('Error fetching status:', error);
          finishLoading();
        }
      };

      pollStatus();

      return () => {};
    }
  }, [dispatch, navigate, processId]);

  if (!isMobile()) {
    return (
      <div className="wizard-step wizard-loading-step wizard-loading-step-ai-desktop justify-center">
        <div className="wizard-splash__loader mb-5 self-center" />
        <p className="font-medium text-center text-md mb-2">{t('onboarding.assistant.loadingTitle')}</p>
        <p className="font-semibold text-2xl text-center">{t('onboarding.assistant.loadingSubtitle')}</p>
      </div>
    );
  }

  return (
    <div className="wizard-step wizard-loading-step justify-center">
      <div className="wizard-splash__loader mb-10 self-center" />
      <p className="font-semibold text-center">{t('onboarding.assistant.loadingTitle')}</p>
      <p className="font-semibold text-xl text-center">{t('onboarding.assistant.loadingSubtitle')}</p>
    </div>
  )
}

export default LoadingStepAI
